import { IPricingMethod } from '@/model/types/goods'

// 获取区间价格
export function intervalSalePrices(prices: any[], key: string = 'sale_price') {
    const allPrice = prices.reduce((a, b) => a.concat(+b[key]), [] as number[])

    return {
        max: Math.max(...allPrice),
        min: Math.min(...allPrice),
    }
}

// 获取区间价格
export function intervalPriceMethod(prices: IPricingMethod) {
    const allPrice = prices.sale_prices.reduce((a, b) => a.concat(+b.sale_price), [] as number[])

    return {
        max: Math.max(...allPrice),
        min: Math.min(...allPrice),
    }
}

// 获取区间价格
export function intervalPrice(prices: IPricingMethod[]) {
    const pricesArr = prices.map(item => {
        return item.sale_prices.map(val => +val.sale_price)
    })

    return {
        max: Math.max(...pricesArr.reduce((a, b) => a.concat(b), [])),
        min: Math.min(...pricesArr.reduce((a, b) => a.concat(b), [])),
    }
}

export function intervalMemberPrice(prices: IPricingMethod[]) {
    let pricesArr = prices
        .filter(item => {
            return +item.member_price.sale_price > 0
        })
        .map(item => {
            return +item.member_price.sale_price
        })

    return {
        length: pricesArr.length,
        max: Math.max(...pricesArr),
        min: Math.min(...pricesArr),
    }
}
